/* Magnetic Skin — landing produit (sections ms-*)
   Les données viennent des sections via <script type="application/json">.
   Tout est en délégation d'événements : ça continue de marcher quand l'éditeur
   de thème recharge une section (shopify:section:load). */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const readJSON = id => { const el = document.getElementById(id); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };
  const esc = t => String(t ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fill = (tpl, vars) => String(tpl || '').replace(/\[(\w+)\]/g, (m, k) => (k in vars ? vars[k] : m));
  const plural = (n, one, many) => (n > 1 ? many : one);
  // Funnel analyzer (snippet ms-funnel) : étapes du parcours. Ne bloque jamais la page.
  const track = (name, data) => { try { if (window.mskTrack) window.mskTrack(name, data); } catch (e) {} };

  let D = null;      // données produit (section ms-product)
  let CART = null;   // libellés du tiroir panier (section ms-cart-drawer)
  let LAST = null;   // dernier panier affiché (suivi des quantités)
  let upsellSeen = false, viewItemSent = false;
  const state = { bundle: 0, jars: [], editing: null, img: 0 };

  /* ---------- Argent : format de la boutique ---------- */
  function money(cents) {
    const fmt = (D && D.moneyFormat) || '${{amount}}';
    const n = (cents / 100);
    const withSep = (num, dec, th, ds) => { const [a, b] = num.toFixed(dec).split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (b ? ds + b : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: withSep(n, 2, ',', '.'),
      amount_no_decimals: withSep(n, 0, ',', '.'),
      amount_with_comma_separator: withSep(n, 2, '.', ','),
      amount_no_decimals_with_comma_separator: withSep(n, 0, '.', ','),
      amount_with_apostrophe_separator: withSep(n, 2, "'", '.'),
    }[k] ?? withSep(n, 2, ',', '.')));
  }

  /* ---------- Calculs packs ---------- */
  const unit = () => (D.variants[0] || { price: 0 }).price;
  const cmpUnit = () => Math.max(unit(), (D.variants[0] || { compare: 0 }).compare || 0);
  const calc = b => { const jars = b.paid + b.free, price = b.paid * unit(), compare = jars * cmpUnit(); return { jars, price, compare, save: compare - price }; };
  const variantFor = i => D.variants.find(v => v.name === (D.scents[i] || {}).name) || D.variants[0];
  const maxJars = () => Math.max(1, ...D.bundles.map(b => b.paid + b.free));

  function initState() {
    D = readJSON('ms-data');
    CART = readJSON('ms-cart-data') || {};
    if (!D) return false;
    if (!D.scents.length) D.scents = [{ name: D.variants[0] ? D.variants[0].name : 'Scent', like: '', tag: '', img: '' }];
    const sel = D.bundles.findIndex(b => b.selected);
    if (!state.jars.length) state.bundle = sel >= 0 ? sel : Math.max(0, D.bundles.length - 1);
    state.bundle = Math.min(state.bundle, D.bundles.length - 1);
    const first = !state.jars.length;
    // Précharge les vignettes des parfums : la fenêtre « Choose your scent » s'ouvre sans cases vides
    if (!window.__msPreloaded) { window.__msPreloaded = true; D.scents.forEach(s => { if (s.img) { const im = new Image(); im.src = s.img; } }); }
    const need = maxJars();
    for (let i = state.jars.length; i < need; i++) state.jars.push(i % D.scents.length);
    // Parfum mis en avant : lien ?variant=ID, sinon métachamp custom.default_scent du produit.
    // Tous les pots prennent ce parfum et le pack présélectionné (Buy 2 Get 1 par défaut) est choisi.
    if (first) {
      const vid = +new URLSearchParams(location.search).get('variant');
      const v = vid && D.variants.find(x => x.id === vid);
      const featured = v ? v.name : D.defaultScent;
      const si = featured ? D.scents.findIndex(s => s.name === featured) : -1;
      if (si >= 0) {
        state.jars = state.jars.map(() => si);
        const pb = (D.presetBundle || 2) - 1;
        if (D.bundles[pb]) state.bundle = pb;
      }
      // Lien ?bundle=N (1 = premier pack) : présélectionne ce pack, ex. bouton « Build your 5-jar bundle » de la home
      const qb = +new URLSearchParams(location.search).get('bundle');
      if (qb && D.useBundleParam !== false && D.bundles[qb - 1]) state.bundle = qb - 1;
    }
    return true;
  }

  /* ---------- Rendu des pots ---------- */
  const imgTag = (src, label, eager) => (src ? `<img src="${esc(src)}" alt=""${eager ? '' : ' loading="lazy"'}>` : esc(label || ''));
  function jarRow(i, isFree) {
    const s = D.scents[state.jars[i]] || D.scents[0];
    return `<div class="jar" data-ms-jar="${i}"><div class="n"><small>${esc(D.labels.jar)}</small>${i + 1}</div><div class="ph">${imgTag(s.img, 'IMG')}</div>
      <div><div class="nm">${esc(s.name)}${isFree ? `<span class="free">${esc(D.labels.free)}</span>` : ''}</div>${s.like ? `<div class="sl">${esc(D.labels.smellsLike)} <b>${esc(s.like)}</b></div>` : ''}</div><span class="chev">⌄</span></div>`;
  }
  const atcLabel = b => { const c = calc(b); return b.free ? fill(D.labels.atcBundle, { jars: c.jars, free: b.free, paid: b.paid }) : D.labels.atcSingle; };

  function renderBundles() {
    const cards = $$('[data-ms-bundle]');
    if (!cards.length) return;
    cards.forEach(card => {
      const bi = +card.dataset.msBundle, b = D.bundles[bi]; if (!b) return;
      card.classList.toggle('on', bi === state.bundle);
      const jarsEl = $('.jars', card);
      if (jarsEl) jarsEl.innerHTML = bi === state.bundle ? Array.from({ length: b.paid + b.free }, (_, i) => jarRow(i, i >= b.paid)).join('') : '';
    });
    const b = D.bundles[state.bundle], c = calc(b);
    $$('[data-ms-sub-compare]').forEach(e => e.textContent = c.save > 0 ? money(c.compare) : '');
    $$('[data-ms-sub-total]').forEach(e => e.textContent = money(c.price));
    $$('[data-ms-saving]').forEach(e => { e.textContent = fill(D.labels.saving, { amount: money(c.save) }); e.style.display = c.save > 0 ? '' : 'none'; });
    $$('[data-ms-ship-msg]').forEach(e => e.textContent = D.freeShipOver > 0 && c.price < D.freeShipOver ? fill(D.labels.shipBelow, { amount: money(D.freeShipOver) }) : D.labels.shipUnlocked);
    $$('[data-ms-atc="main"] b').forEach(e => e.textContent = atcLabel(b));
    // Barre fixe
    $$('[data-ms-sticky-name]').forEach(e => e.textContent = `${(D.scents[state.jars[0]] || {}).name || ''} · ${c.jars} ${plural(c.jars, D.labels.jarWord, D.labels.jarsWord)}`);
    $$('[data-ms-sticky-total]').forEach(e => e.textContent = money(c.price));
    $$('[data-ms-sticky-save]').forEach(e => e.textContent = c.save > 0 ? fill(D.labels.save, { amount: money(c.save) }) : '');
    $$('[data-ms-atc="sticky"]').forEach(e => e.textContent = '🛒 ' + atcLabel(b));
  }

  function renderFinal() {
    $$('[data-ms-final]').forEach(sec => {
      const bi = Math.min(+sec.dataset.msFinal || 0, D.bundles.length - 1), b = D.bundles[bi]; if (!b) return;
      const c = calc(b);
      const list = $('[data-ms-final-jars]', sec);
      if (list) list.innerHTML = Array.from({ length: c.jars }, (_, i) => {
        const s = D.scents[state.jars[i]] || D.scents[0], isFree = i >= b.paid;
        return `<div class="f-jar" data-ms-jar="${i}"><div class="n"><small>${esc(D.labels.jar)}</small>${i + 1}</div>
          <div class="card"><div class="ph">${imgTag(s.img, 'IMG')}</div><div><div class="nm">${esc(s.name)}</div>${s.like ? `<div class="sl">${esc(D.labels.smellsLike)} <b>${esc(s.like)}</b></div>` : ''}</div>
          <div class="p">${isFree ? `<span class="free" style="margin:0">${esc(D.labels.free)}</span><small><s>${money(cmpUnit())}</s></small>` : `${money(unit())}<small>${esc(D.labels.each)}</small>`}</div></div></div>`;
      }).join('');
      $$('[data-ms-final-compare]', sec).forEach(e => e.textContent = c.save > 0 ? money(c.compare) : '');
      $$('[data-ms-final-total]', sec).forEach(e => e.textContent = money(c.price));
      $$('[data-ms-final-save]', sec).forEach(e => {
        const lbl = String(D.labels.saving || '').replace(/^[^\p{L}\p{N}\[]+/u, '');   // retire l'emoji de tête (l'icône SVG suffit)
        e.innerHTML = '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M1.5 7.5V1.5h6l5.5 5.5-6 6z"/><circle cx="4.5" cy="4.5" r="1"/></svg><span>' + esc(lbl).replace('[amount]', '<b>' + money(c.save) + '</b>') + '</span>';
        e.style.display = c.save > 0 ? '' : 'none';
      });
      $$('[data-ms-final-atc] b', sec).forEach(e => { if (!e.dataset.custom) e.textContent = atcLabel(b); });
    });
  }

  /* ---------- Fenêtre parfum ---------- */
  function renderOpts() {
    const box = $('[data-ms-opts]'); if (!box) return;
    box.innerHTML = D.scents.map((s, i) => `<div class="opt ${state.jars[state.editing] === i ? 'on' : ''}" data-ms-opt="${i}">
      <div class="ph">${imgTag(s.img, 'IMG', true)}</div><div><b>${esc(s.name)}</b>${s.like ? `<small>${esc(D.labels.smellsLike)} ${esc(s.like)}</small>` : ''}</div>${s.tag ? `<em>${esc(s.tag)}</em>` : ''}</div>`).join('');
  }
  const openModal = i => { state.editing = i; renderOpts(); $('[data-ms-modal]')?.classList.add('open'); };
  const closeModal = () => { $('[data-ms-modal]')?.classList.remove('open'); renderBundles(); renderFinal(); };

  /* ---------- Galerie ---------- */
  function showSlide(gal, i) {
    const slides = $$('.slide', gal); if (!slides.length) return;
    const n = slides.length; i = (i + n) % n; gal.dataset.current = i;
    slides.forEach((s, k) => s.classList.toggle('on', k === i));
    $$('[data-ms-thumb]', gal.closest('.gallery') || gal).forEach((t, k) => t.classList.toggle('on', k === i));
    $$('.dots i', gal).forEach((t, k) => t.classList.toggle('on', k === i));
  }

  /* ---------- Panier ---------- */
  const cartRoot = () => $('[data-ms-cart]');
  function openCart(source) { track('view_cart', { source: source || 'icon' }); upsellSeen = false; const r = cartRoot(); if (!r) { location.href = '/cart'; return; } r.classList.add('open'); $('[data-ms-cart-overlay]')?.classList.add('open'); r.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; refreshCart(); }
  function closeCart() { const r = cartRoot(); if (!r) return; r.classList.remove('open'); $('[data-ms-cart-overlay]')?.classList.remove('open'); r.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  async function refreshCart() { try { renderCart(await (await fetch('/cart.js')).json()); } catch (e) {} }
  async function changeLine(key, quantity) {
    const line = LAST && LAST.items.find(i => i.key === key);
    track('cart_change', { from: line ? line.quantity : null, to: quantity, addon: !!(line && LAST.addonIds.includes(line.variant_id)) });
    const r = cartRoot(); r?.classList.add('busy');
    try { const res = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) }); renderCart(await res.json()); } catch (e) {}
    r?.classList.remove('busy');
  }
  async function addBundle(bi, button) {
    const b = D.bundles[bi], c = calc(b);
    const qty = {}; state.jars.slice(0, c.jars).forEach(i => { const v = variantFor(i); qty[v.id] = (qty[v.id] || 0) + 1; });
    const btns = $$('[data-ms-atc],[data-ms-final-atc]'); btns.forEach(x => { x.disabled = true; x.style.opacity = .7; });
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: Object.entries(qty).map(([id, q]) => ({ id: +id, quantity: q })) }) });
      if (!r.ok) throw new Error((await r.json()).description || 'Add to cart failed');
      const utm = {}; new URLSearchParams(location.search).forEach((val, k) => { if (/^utm_|fbclid|ttclid|gclid/.test(k)) utm[k] = val; });
      if (Object.keys(utm).length) await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: utm }) });
      track('add_to_cart', { jars: c.jars, paid: b.paid, free: b.free, value: c.price / 100, scents: state.jars.slice(0, c.jars).map(i => (D.scents[i] || {}).name), button: button || 'main' });
      openCart('after_add');
    } catch (e) { track('add_to_cart_error', { message: String(e.message || e).slice(0, 120) }); alert(e.message); }
    btns.forEach(x => { x.disabled = false; x.style.opacity = 1; });
  }

  /* ---------- Upsell du panier : « Pairs with your order » ----------
     Propose les autres parfums. Le prix affiché suit les paliers de pots offerts :
     si le prochain pot ajouté débloque un pot offert, il est affiché FREE. */
  // Total des pots de la gamme après pots offerts : Shopify offre les pots les moins chers
  // (une seule réduction par commande, la plus avantageuse).
  function familyTotal(prices, tiers) {
    const free = tiers.filter(t => prices.length >= t.need).reduce((m, t) => Math.max(m, t.free), 0);
    const sorted = prices.slice().sort((a, b) => a - b);
    return sorted.reduce((a, p) => a + p, 0) - sorted.slice(0, free).reduce((a, p) => a + p, 0);
  }
  function upsellHTML(cart, jars, tiers, L, ctx) {
    const U = L.upsell; if (!U || !U.items || !cart.items.length) return '';
    const inCart = new Set(cart.items.map(i => i.variant_title));
    const list = U.items.filter(x => x.available).sort((a, b) => inCart.has(a.name) - inCart.has(b.name)).slice(0, 6);
    if (!list.length) return '';
    // 2e pot à prix panier : seulement si le panier contient 1 pot à prix normal et aucun add-on
    const addonOK = ctx.addonQty === 0 && ctx.fullJars === 1 && jars === 1 && (U.addon || []).length > 0;
    const offer = x => {
      const a = addonOK && U.addon.find(v => v.name === x.name && v.available);
      const v = a || x, delta = familyTotal(ctx.prices.concat(v.price), tiers) - familyTotal(ctx.prices, tiers);
      return { id: v.id, delta, addon: !!a };
    };
    const offers = list.map(offer), first = offers[0];
    const next = tiers.find(t => jars < t.need), n = next ? next.need - jars : 0;
    const pill = first.delta === 0 ? U.pillFree
      : first.addon ? U.pillAddon
      : first.delta < list[0].price ? fill(U.pillDeal, { price: money(first.delta) })
      : !next ? U.pillMax : fill(U.pillMore, { n: n - 1 });
    const cards = list.map((x, i) => {
      const o = offers[i], isFree = o.delta === 0, isDeal = !isFree && o.delta < x.price;
      const pct = x.compare > x.price ? Math.round((1 - x.price / x.compare) * 100) : 0;
      const priceHTML = isFree
        ? `<s>${money(x.price)}</s><b>${esc(L.freeWord)}</b>`
        : isDeal
          ? `<b>${money(o.delta)}</b><s>${money(x.price)}</s><span class="save">${o.addon ? esc(U.addonTag) : `Save ${money(x.price - o.delta)}`}</span>`
          : `<b>${money(x.price)}</b>${x.compare > x.price ? `<s>${money(x.compare)}</s><span class="save">Save ${pct}%</span>` : ''}`;
      return `<div class="up-c${isFree ? ' is-free' : isDeal ? ' is-deal' : ''}">
        <div class="up-top">
          <div class="up-img">${x.img ? `<img src="${esc(x.img)}" alt="" loading="lazy" width="64" height="64">` : ''}</div>
          <div class="up-b">
            <div class="up-n">${esc(x.name)}${x.badge ? `<span class="up-badge">${esc(x.badge)}</span>` : ''}</div>
            <div class="up-pr">${priceHTML}</div>
            ${x.like ? `<div class="up-sc">${esc(L.inspired)} <b>${esc(x.like)}</b></div>` : ''}
          </div>
        </div>
        <button type="button" class="up-btn" data-ms-up-add="${o.id}">+ ${esc(U.button)} — ${isFree ? esc(L.freeWord) : money(o.delta)}</button>
      </div>`;
    }).join('');
    const dots = list.length > 1 ? `<div class="up-dots">${list.map((x, i) => `<button type="button" data-ms-up-dot="${i}" class="${i ? '' : 'on'}" aria-label="${esc(x.name)}"></button>`).join('')}</div>` : '';
    return `<div class="cdr-up">
      <div class="up-h"><span>${esc(U.title)}</span></div>
      <div class="up-sub"><span class="up-pill${first.delta === 0 ? ' is-free' : ''}">${esc(pill)}</span>${list.length > 1 ? `<span class="up-swipe">${esc(U.swipe)} →</span>` : ''}</div>
      <div class="up-track" data-ms-up-track>${cards}</div>${dots}
    </div>`;
  }
  async function addUpsell(id, btn) {
    const r = cartRoot(); r?.classList.add('busy'); if (btn) btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
      if (!res.ok) throw new Error((await res.json()).description || 'Add to cart failed');
      track('cart_upsell_add', { variant: id });
      await refreshCart();
    } catch (e) { alert(e.message); }
    r?.classList.remove('busy'); if (btn) btn.disabled = false;
  }
  // Points du carrousel : suivent le défilement (l'événement scroll ne remonte pas, d'où la capture)
  document.addEventListener('scroll', e => {
    const tr = e.target; if (!(tr instanceof Element) || !tr.matches('[data-ms-up-track]')) return;
    const w = tr.children[0] ? tr.children[0].offsetWidth : 1, i = Math.round(tr.scrollLeft / w);
    $$('[data-ms-up-dot]', tr.parentElement).forEach((d, k) => d.classList.toggle('on', k === i));
  }, true);

  const CHK = '<svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="11"/><path d="M7 12.5l3.2 3L17 9" stroke="#fff" stroke-width="2.4" fill="none"/></svg>';
  function renderCart(cart) {
    $$('[data-ms-cart-count]').forEach(e => e.textContent = cart.item_count || '');
    tickReserve(cart.item_count || 0);
    const r = cartRoot(); if (!r) return;
    const L = CART || {};
    $$('[data-ms-cart-badge]', r).forEach(e => e.textContent = cart.item_count || 0);
    const pid = D ? D.productId : null;
    const UP = L.upsell || null;
    // Tous les parfums (un produit par parfum) comptent ensemble pour les pots offerts.
    // Hors fiche produit, le type de produit vient de l'upsell du tiroir.
    const famType = (D && D.productType) || (UP && UP.family) || '';
    const inFamily = it => (famType && it.product_type ? it.product_type === famType : !!(D && it.product_id === pid));
    const jars = cart.items.filter(inFamily).reduce((a, i) => a + i.quantity, 0);
    // Pot add-on (2e pot à prix panier) : 1 au maximum, et jamais sans pot à prix normal
    const ADD = new Set(((UP && UP.addon) || []).map(a => a.id));
    const addonLines = cart.items.filter(i => ADD.has(i.variant_id));
    const addonQty = addonLines.reduce((a, i) => a + i.quantity, 0), fullJars = jars - addonQty;
    if (addonQty && (fullJars < 1 || addonQty > 1)) {
      const l = addonLines[0]; changeLine(l.key, fullJars < 1 ? 0 : Math.max(0, l.quantity - (addonQty - 1))); return;
    }
    LAST = { items: cart.items, addonIds: [...ADD] };
    if (window.MSK_CFG) window.MSK_CFG.cartSummary = () => ({ units: cart.item_count, value: cart.total_price / 100, jars, addon: addonQty });
    const upCtx = { addonQty, fullJars, prices: cart.items.filter(inFamily).flatMap(i => Array(i.quantity).fill(i.original_price)) };
    // Paliers de pots offerts : packs de la fiche produit, sinon réglage du tiroir
    const tiers = (D ? D.bundles.filter(b => b.free > 0).map(b => ({ need: b.paid + b.free, free: b.free })) : ((UP && UP.tiers) || [])).sort((a, b) => a.need - b.need);
    // Progression vers les pots offerts
    const prog = $('[data-ms-cart-progress]', r);
    if (prog && tiers.length) {
      const reached = tiers.filter(t => jars >= t.need).pop(), next = tiers.find(t => jars < t.need);
      const top = tiers.length ? tiers[tiers.length - 1].need : 1;
      let html = '';
      if (reached) html += `<div class="lbl">${CHK} ${esc(fill(L.unlocked, { free: reached.free, jars: plural(reached.free, L.jarWord, L.jarsWord) }))}</div>`;
      if (next) { const n = next.need - jars; html += `<div class="lbl todo"${reached ? ' style="margin-top:3px"' : ''}>${esc(fill(L.todo, { n, free: next.free, jars: plural(n, L.jarWord, L.jarsWord) }))}</div>`; }
      prog.innerHTML = html + `<div class="bar"><i style="width:${Math.min(jars / top, 1) * 100}%"></i></div>`;
      prog.style.display = tiers.length ? '' : 'none';
    }
    const items = $('[data-ms-cart-items]', r), foot = $('[data-ms-cart-foot]', r);
    if (!cart.items.length) { items.innerHTML = `<div class="cdr-empty">${esc(L.empty)}</div>`; foot.style.display = 'none'; return; }
    foot.style.display = '';
    const rows = []; let freeTotal = 0;
    cart.items.forEach(it => {
      const unitP = it.original_line_price / it.quantity, saved = it.original_line_price - it.final_line_price;
      const vv = D && D.variants.find(v => v.id === it.variant_id), cmpU = Math.max(unitP, vv && vv.compare ? vv.compare : 0);
      const freeQty = inFamily(it) ? Math.min(it.quantity, Math.floor((saved + 1) / unitP)) : 0;
      freeTotal += freeQty * unitP;
      if (freeQty > 0 && freeQty < it.quantity) {
        rows.push({ it, qty: it.quantity - freeQty, orig: cmpU * (it.quantity - freeQty), fin: it.final_line_price, free: false, stepper: true });
        rows.push({ it, qty: freeQty, orig: cmpU * freeQty, fin: 0, free: true, stepper: false });
      } else rows.push({ it, qty: it.quantity, orig: cmpU * it.quantity, fin: it.final_line_price, free: freeQty > 0, stepper: true });
    });
    rows.sort((a, b) => b.free - a.free);
    items.innerHTML = rows.map(({ it, qty, orig, fin, free, stepper }) => {
      const sc = (D && D.scents.find(s => s.name === it.variant_title)) || (UP && (UP.items || []).filter(x => x.like).map(x => ({ name: x.name, like: x.like })).find(s => s.name === it.variant_title));
      const tag = free ? ((it.line_level_discount_allocations || [])[0] || { discount_application: { title: L.freeApplied } }).discount_application.title : '';
      const k = esc(it.key), img = it.image ? it.image + (it.image.includes('?') ? '&' : '?') + 'width=160' : '';
      return `<div class="ci ${free ? 'is-free' : ''}">
        <div class="ci-img">${img ? `<img src="${esc(img)}" alt="">` : ''}</div>
        <div class="ci-b">
          <div class="ci-n">${free ? `<span class="ci-pill">${esc(L.freePill)}</span>` : ''}${esc(it.variant_title || it.product_title)}${!free && ADD.has(it.variant_id) && UP.addonTag ? `<span class="ci-pill">${esc(UP.addonTag)}</span>` : ''}</div>
          <div class="ci-sc">${sc && sc.like ? `${esc(L.inspired)} <b>${esc(sc.like)}</b>` : esc(it.product_title)}</div>
          ${free ? `<div class="ci-ok">${CHK} ${esc(tag)}</div>` : ''}
          <div class="ci-r">
            ${stepper ? `<div class="qty"><button type="button" aria-label="Decrease" data-ms-line="${k}" data-qty="${it.quantity - 1}">−</button><span>${qty}</span><button type="button" aria-label="Increase" data-ms-line="${k}" data-qty="${it.quantity + 1}">+</button></div>` : `<span class="ci-q">Qty: ${qty}</span>`}
            <div class="ci-pr">${orig > fin ? `<s>${money(orig)}</s>` : ''}<b>${fin === 0 ? esc(L.freeWord) : money(fin)}</b></div>
          </div>
        </div>
        ${stepper ? `<button class="ci-del" type="button" aria-label="Remove" data-ms-line="${k}" data-qty="0">✕</button>` : ''}
      </div>`;
    }).join('') + upsellHTML(cart, jars, tiers, L, upCtx);
    const upCards = items.querySelectorAll('.up-c').length;
    if (upCards && !upsellSeen && r.classList.contains('open')) { upsellSeen = true; track('cart_upsell_view', { cards: upCards, jars }); }
    const origTot = rows.reduce((a, x) => a + x.orig, 0), other = Math.max(0, origTot - cart.total_price - freeTotal);
    const set = (sel, v, show) => { const e = $(sel, r); if (!e) return; e.textContent = v; const row = e.closest('[data-ms-row]'); if (row && show !== undefined) row.style.display = show ? '' : 'none'; };
    set('[data-ms-os-orig]', money(origTot));
    set('[data-ms-os-disc]', '−' + money(other), other > 0);
    set('[data-ms-os-free]', '−' + money(freeTotal), freeTotal > 0);
    set('[data-ms-os-final]', money(cart.total_price));
    set('[data-ms-os-total]', money(cart.total_price));
    set('[data-ms-os-items]', `(${cart.item_count} ${plural(cart.item_count, L.item, L.items)})`);
  }

  /* ---------- Divers ---------- */
  function fillDates() {
    $$('[data-ms-date]').forEach(e => { const d = new Date(); d.setDate(d.getDate() + (+e.dataset.msDate || 0)); e.textContent = d.toLocaleDateString(e.dataset.locale || 'en-US', { weekday: 'long', month: 'short', day: 'numeric' }); });
  }
  // Jour d'expédition : n jours ouvrés (samedi et dimanche ne comptent pas)
  function fillShipBy() {
    $$('[data-ms-shipby]').forEach(e => {
      const d = new Date(); let n = +e.dataset.msShipby || 0;
      while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      e.textContent = d.toLocaleDateString(e.dataset.locale || 'en-US', { weekday: 'long' });
    });
  }
  // « 2026-11-02 23:59 » lu à l'heure de New York (gère l'heure d'été)
  function nyDeadline(str) {
    const m = String(str || '').trim().match(/^(\d{4}-\d{2}-\d{2})(?:[ T](\d{1,2}:\d{2}))?$/); if (!m) return null;
    const guess = new Date(`${m[1]}T${(m[2] || '23:59').padStart(5, '0')}:00Z`); if (isNaN(guess)) return null;
    const asUTC = new Date(guess.toLocaleString('en-US', { timeZone: 'UTC' })), asNY = new Date(guess.toLocaleString('en-US', { timeZone: 'America/New_York' }));
    return new Date(guess.getTime() + (asUTC - asNY));
  }
  // Date du jour à New York (année, mois, jour, heure, jour de la semaine)
  function nyNow() {
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short' }).formatToParts(new Date()).map(x => [x.type, x.value]));
    return { ymd: `${p.year}-${p.month}-${p.day}`, hour: +p.hour % 24, min: +p.minute };
  }
  // Dates calendaires (midi UTC pour éviter les décalages d'heure d'été)
  const ymdDate = ymd => new Date(`${ymd}T12:00:00Z`);
  const isWeekend = d => d.getUTCDay() === 0 || d.getUTCDay() === 6;
  function addBusinessDays(d, n) { const r = new Date(d); while (n > 0) { r.setUTCDate(r.getUTCDate() + 1); if (!isWeekend(r)) n--; } return r; }
  const fmtDay = d => d.toLocaleDateString('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' });
  // Bloc livraison : temps restant avant l'heure limite + fourchette de livraison en jours ouvrés
  function fillDelivery() {
    $$('[data-ms-delivery]').forEach(el => {
      const cut = +el.dataset.cutoff || 0, proc = +el.dataset.proc || 0, tmin = +el.dataset.tmin || 0, tmax = +el.dataset.tmax || tmin;
      const now = nyNow(); let day = ymdDate(now.ymd);
      // Commande comptée aujourd'hui seulement un jour ouvré avant l'heure limite
      if (isWeekend(day) || now.hour >= cut) { day = addBusinessDays(day, 1); }
      while (isWeekend(day)) day.setUTCDate(day.getUTCDate() + 1);
      const end = nyDeadline(`${day.toISOString().slice(0, 10)} ${String(cut).padStart(2, '0')}:00`);
      const left = Math.max(0, Math.floor((end - Date.now()) / 60000)), h = Math.floor(left / 60), m = left % 60;
      const time = h >= 24 ? `${Math.floor(h / 24)}d ${h % 24}h` : `${h}h ${String(m).padStart(2, '0')}m`;
      const shipped = addBusinessDays(day, proc), from = addBusinessDays(shipped, tmin), to = addBusinessDays(shipped, tmax);
      const dates = tmin === tmax ? fmtDay(from) : `${fmtDay(from)} – ${fmtDay(to)}`;
      el.innerHTML = esc(el.dataset.tpl || '').replace('[time]', `<b>${esc(time)}</b>`).replace('[dates]', `<b>${esc(dates)}</b>`);
    });
  }
  // Ligne « Noël » : visible entre la date de début et la date limite (heure de New York)
  function fillWindows() {
    const today = nyNow().ymd;
    $$('[data-ms-window]').forEach(el => {
      const [start, end] = (el.dataset.msWindow || '').split('|').map(x => x.trim());
      const on = !!end && (!start || today >= start) && today <= end;
      el.hidden = !on;
      if (on) el.textContent = (el.dataset.tpl || '').replace('[date]', ymdDate(end).toLocaleDateString('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric' }));
    });
  }
  // Compte à rebours vers une vraie date de fin : masqué avant le chargement et après la date
  function tickDeadlines() {
    $$('[data-ms-deadline]').forEach(el => {
      // Option « recommencer toutes les X heures » : cycle calé sur minuit à New York
      const loop = (+el.dataset.msLoop || 0) * 3600;
      let s;
      if (loop > 0) {
        // Si le cycle se termine pendant la visite, le compte à rebours disparaît au lieu de repartir sous les yeux du visiteur
        if (el.dataset.msLoopDone) { el.hidden = true; return; }
        const nyOff = (new Date(new Date().toLocaleString('en-US', { timeZone: 'UTC' })) - new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }))) / 1000;
        const t = Math.floor(Date.now() / 1000 - nyOff - (+el.dataset.msLoopAt || 0) * 3600);
        s = loop - (((t % loop) + loop) % loop);
        const prev = +el.dataset.msLast || 0; el.dataset.msLast = s;
        if (prev && s > prev + 5) { el.dataset.msLoopDone = '1'; el.hidden = true; return; }
      }
      else { const end = nyDeadline(el.dataset.msDeadline); s = end ? Math.floor((end - Date.now()) / 1000) : -1; }
      if (s <= 0) { el.hidden = true; return; }
      el.hidden = false;
      const v = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60].map(x => String(x).padStart(2, '0'));
      $$('.cd span', el).forEach((e, i) => e.textContent = v[i]);
      // Case « jours » masquée quand il reste moins d'un jour
      const dayBox = $('.cd div', el); if (dayBox && $$('.cd div', el).length === 4) dayBox.hidden = v[0] === '00';
    });
  }
  // Minuteur « panier réservé » (option du tiroir panier), démarré au premier article ajouté
  const RES_KEY = 'msCartReserveStart';
  function tickReserve(itemCount) {
    const el = $('[data-ms-cart-reserve]'); if (!el) return;
    if (itemCount === 0) { try { sessionStorage.removeItem(RES_KEY); } catch (e) {} el.hidden = true; return; }
    if (itemCount > 0) { try { if (!sessionStorage.getItem(RES_KEY)) sessionStorage.setItem(RES_KEY, String(Date.now())); } catch (e) {} }
    let start = 0; try { start = +sessionStorage.getItem(RES_KEY) || 0; } catch (e) {}
    if (!start) { el.hidden = true; return; }
    const left = Math.max(0, Math.floor(((+el.dataset.min || 10) * 60000 - (Date.now() - start)) / 1000));
    const t = `${String(Math.floor(left / 60)).padStart(2, '0')}:${String(left % 60).padStart(2, '0')}`;
    el.innerHTML = left > 0 ? `<span class="dot"></span>${esc(el.dataset.tpl || '').replace('[time]', `<b>${t}</b>`)}` : esc(el.dataset.done || '');
    el.classList.toggle('is-done', left === 0);
    el.hidden = false;
  }
  function sortGrid(sel) {
    const grid = sel.closest('.ms-cg')?.querySelector('[data-ms-grid]'); if (!grid) return;
    const items = [...grid.children];
    const tiles = items.map((el, i) => el.matches('[data-ms-tile]') ? [i, el] : null).filter(Boolean);
    const cards = items.filter(el => el.matches('[data-ms-card]'));
    const by = { featured: (a, b) => a.dataset.i - b.dataset.i, 'price-asc': (a, b) => a.dataset.price - b.dataset.price,
      'price-desc': (a, b) => b.dataset.price - a.dataset.price, name: (a, b) => a.dataset.name.localeCompare(b.dataset.name) }[sel.value] || (() => 0);
    cards.sort(by);
    const out = cards.slice(); tiles.forEach(([i, el]) => out.splice(Math.min(i, out.length), 0, el));
    out.forEach(el => grid.appendChild(el));
  }
  document.addEventListener('change', e => {
    if (e.target.matches('[data-ms-sort]')) sortGrid(e.target);
    if (e.target.matches('[data-ms-reason]')) syncOrderRequired(e.target);
  });
  // Formulaire SAV : n° de commande obligatoire seulement pour les motifs liés à une commande
  function syncOrderRequired(sel) {
    const form = sel.closest('form'); const input = form && form.querySelector('[data-ms-order-field] input'); if (!input) return;
    const list = (sel.dataset.orderReasons || '').split(/\n|<br \/>/).map(x => x.trim()).filter(Boolean);
    const need = list.includes((sel.value || '').toLowerCase());
    input.required = need; form.querySelector('[data-ms-order-req]')?.toggleAttribute('hidden', !need);
  }
  // Suivi : ouvre le site de suivi avec le numéro saisi
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-ms-track-form]'); if (!f) return;
    e.preventDefault();
    const n = (f.querySelector('input[name=tracking]').value || '').trim(); if (!n) return;
    window.open((f.dataset.url || 'https://t.17track.net/en#nums={number}').replace('{number}', encodeURIComponent(n)), '_blank', 'noopener');
  });
  function tickCountdowns() {
    $$('[data-ms-countdown]').forEach(cd => {
      const n = new Date(), m = new Date(n); m.setHours(24, 0, 0, 0); const s = Math.floor((m - n) / 1000);
      const v = [Math.floor(s / 3600), Math.floor(s % 3600 / 60), s % 60].map(x => String(x).padStart(2, '0'));
      $$('span', cd).forEach((e, i) => e.textContent = v[i]);
    });
  }
  let stickyObs = null;
  function watchSticky() {
    stickyObs?.disconnect();
    const target = $('[data-ms-atc="main"]'), bar = $('[data-ms-sticky]');
    if (!target || !bar || bar.dataset.preview) return;
    stickyObs = new IntersectionObserver(([e]) => bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0));
    stickyObs.observe(target);
  }
  function initReviews() {
    $$('[data-ms-review-list]').forEach(list => {
      const per = +list.dataset.perPage || 5, rows = $$('.rv', list);
      rows.forEach((r, i) => r.classList.toggle('is-hidden', i >= per));
      const btn = list.parentElement.querySelector('[data-ms-more]');
      if (btn) btn.style.display = rows.length > per ? '' : 'none';
      list.dataset.shown = per;
      updateShowing(list);
    });
  }
  function updateShowing(list) {
    const el = list.parentElement.querySelector('[data-ms-showing]'); if (!el) return;
    const shown = Math.min(+list.dataset.shown || 0, $$('.rv', list).length);
    el.textContent = (el.dataset.tpl || '').replace('[shown]', shown).replace('[total]', el.dataset.total || '');
  }

  /* ---------- Événements (délégation, une seule fois) ---------- */
  document.addEventListener('click', e => {
    const t = e.target;
    const jar = t.closest('[data-ms-jar]'); if (jar && D) { e.stopPropagation(); openModal(+jar.dataset.msJar); return; }
    // Choix d'un parfum : appliqué au pot et fermeture immédiate
    const opt = t.closest('[data-ms-opt]'); if (opt && D) { state.jars[state.editing] = +opt.dataset.msOpt; closeModal(); return; }
    if (t.closest('[data-ms-modal-close]') || t.matches('[data-ms-modal]')) { closeModal(); return; }
    const card = t.closest('[data-ms-bundle]'); if (card && D) { const from = state.bundle; state.bundle = +card.dataset.msBundle; if (from !== state.bundle) track('select_pack', { jars: calc(D.bundles[state.bundle]).jars, from: calc(D.bundles[from]).jars }); renderBundles(); return; }
    const atc = t.closest('[data-ms-atc]'); if (atc && D) { e.preventDefault(); addBundle(state.bundle, atc.dataset.msAtc); return; }
    const fatc = t.closest('[data-ms-final-atc]'); if (fatc && D) { e.preventDefault(); const bi = +fatc.closest('[data-ms-final]').dataset.msFinal || 0; state.bundle = Math.min(bi, D.bundles.length - 1); renderBundles(); addBundle(state.bundle, 'final'); return; }
    if (t.closest('[data-ms-burger]')) { toggleDrawer(true); return; }
    if (t.closest('[data-ms-drawer-close]')) { toggleDrawer(false); return; }
    if (t.closest('[data-ms-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-ms-cart-close]')) { closeCart(); return; }
    const upAdd = t.closest('[data-ms-up-add]'); if (upAdd) { addUpsell(+upAdd.dataset.msUpAdd, upAdd); return; }
    const upDot = t.closest('[data-ms-up-dot]'); if (upDot) { const tr = upDot.closest('.cdr-up')?.querySelector('[data-ms-up-track]'), card = tr?.children[+upDot.dataset.msUpDot]; if (tr && card) tr.scrollTo({ left: card.offsetLeft - tr.offsetLeft, behavior: 'smooth' }); return; }
    const line = t.closest('[data-ms-line]'); if (line) { changeLine(line.dataset.msLine, +line.dataset.qty); return; }
    const thumb = t.closest('[data-ms-thumb]'); if (thumb) { const gal = $('[data-ms-gallery]', thumb.closest('.gallery')); showSlide(gal, +thumb.dataset.msThumb); return; }
    const arrow = t.closest('[data-ms-slide]'); if (arrow) { const gal = arrow.closest('[data-ms-gallery]'); showSlide(gal, (+gal.dataset.current || 0) + (+arrow.dataset.msSlide)); return; }
    const sc = t.closest('[data-ms-scroll]'); if (sc) { const tr = sc.parentElement.querySelector('[data-ms-track]'); const card = tr && tr.firstElementChild; tr && tr.scrollBy({ left: (+sc.dataset.msScroll) * ((card ? card.offsetWidth : 300) + 14), behavior: 'smooth' }); return; }
    const more = t.closest('[data-ms-more]'); if (more) {
      const list = more.parentElement.querySelector('[data-ms-review-list]'); const step = +list.dataset.perPage || 5;
      const shown = (+list.dataset.shown || step) + step; list.dataset.shown = shown;
      $$('.rv', list).forEach((r, i) => r.classList.toggle('is-hidden', i >= shown));
      if (shown >= $$('.rv', list).length) more.style.display = 'none';
      updateShowing(list);
    }
  });
  function toggleDrawer(open) {
    const dw = $('[data-ms-drawer]'); if (!dw) return;
    dw.classList.toggle('open', open); $('.ms-dw-ov')?.classList.toggle('open', open);
    dw.setAttribute('aria-hidden', open ? 'false' : 'true');
    $('[data-ms-burger]')?.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeCart(); closeModal(); toggleDrawer(false); } });

  function init() {
    const ok = initState();
    fillDates(); fillShipBy(); fillDelivery(); fillWindows(); tickCountdowns(); tickDeadlines(); initReviews();
    $$('[data-ms-reason]').forEach(syncOrderRequired);
    if (ok) { renderBundles(); renderFinal(); watchSticky(); }
    if (ok && !viewItemSent) { viewItemSent = true; const b = D.bundles[state.bundle]; track('view_item', { product: D.productId, preset_jars: b ? calc(b).jars : null, unit: unit() / 100 }); }
    refreshCart();
  }
  setInterval(() => { tickCountdowns(); tickDeadlines(); tickReserve(); }, 1000);
  setInterval(fillDelivery, 30000);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => setTimeout(init, 0));
  document.addEventListener('shopify:block:select', e => { const card = e.target.closest?.('[data-ms-bundle]'); if (card && D) { state.bundle = +card.dataset.msBundle; renderBundles(); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.MagneticSkin = { openCart, closeCart, refreshCart };
})();
